// Define the anchorsAuto function before calling it
const anchorsAuto = function (element) {
    return {
        element: element,
        $body: null,
        $images: null,

        // Initialize the logic of lazy loading behavior and smooth scrolling
        async init() {
            // Select the main content container and lazy-loading images
            this.$body = document.querySelector(".blog-post-content, .help-container-article")
            this.$images = this.$body.querySelectorAll("img[loading=\"lazy\"]")

            const wrapperContainer = document.querySelector(".wp-block-tutkit-anchors-auto")

            wrapperContainer.classList.add("no-min-height")

            // Remove "lazy" loading attribute from images after 1 second to force image load
            setTimeout(() => {
                this.$images.forEach((img) => {
                    img.setAttribute("loading", "")
                })
            }, 1000)

            // Add smooth scrolling behavior for all anchor links in the table of contents
            document.querySelectorAll(".wp-block-tutkit-anchors-auto a[href^=\"#\"]").forEach((anchor) => {
                anchor.addEventListener("click", function (e) {
                    e.preventDefault() // Prevent default anchor link behavior

                    // Get the height of the site's header to calculate offset
                    const menuHeightCompensation = document.querySelector("header.site-header").clientHeight
                    const anchorBlock = document.querySelector(anchor.getAttribute("href"))

                    if (!anchorBlock) return // Ensure the anchor exists

                    const headerOffset = menuHeightCompensation // Offset based on header height
                    const elementPosition = anchorBlock.offsetTop
                    const offsetPosition = elementPosition - headerOffset - 20 // Final scroll position

                    // Scroll to the desired position smoothly
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    })
                })
            })

            return this
        },
    }
}

// Initialize the script based on document's loading state
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAnchorsAuto)
} else {
    initAnchorsAuto()
}

// Function to initialize the auto anchors logic
function initAnchorsAuto() {
    const element = document.querySelector(".wp-block-tutkit-anchors-auto")
    if (element) {
        anchorsAuto(element).init()
    }
}
